export default __webpack_public_path__ + "mixamo.75271f06.png";